import { isNullOrUndefined } from '@app/util/util';
import { HotelFilterTypes } from '@shared/hotel-itinerary/hotel-filters';
import { FilterSorterCriterias, PickedRange } from '@shared/filters/entities/fetch-filters.response';
import { HotelResultPackagesPayload } from '@packages/packages-result/entities/hotel-results';
import { mapFiltersReduce } from '@app/mappers/filters.mapper';
import { HotelFiltersResponse } from '@shared/magic-filter-bar/entities/filter-types';

export function pickedPackageHotelSorter(searchPayload: HotelResultPackagesPayload): FilterSorterCriterias {
  return {
    OrderDesc: searchPayload.OrderDesc,
    OrderCriteria: searchPayload.OrderCriteria
  };
}

export function pickedPackageHotelCheckboxes(payload: HotelResultPackagesPayload): string[] {
  if (Object.keys(payload).length > 0) {
    const defaultChekboxes = [...payload.Zones, ...payload.Ammenities, ...payload.Tags, ...payload.Boards];
    return !isNullOrUndefined(payload.RefundableType) ? [...defaultChekboxes, payload.RefundableType] : defaultChekboxes;
  } else return [];
}

export function pickedPackageHotelRanges(searchPayload: HotelResultPackagesPayload): PickedRange {
  return Object.keys(searchPayload).length === 0 ? {} as PickedRange :
    isNullOrUndefined(searchPayload.PriceFrom) && isNullOrUndefined(searchPayload.PriceTo) ? {} :
      {
        [HotelFilterTypes.Price]: [searchPayload.PriceFrom, searchPayload.PriceTo],
      };
}

export function pickedPackageHotelStars(searchPayload: HotelResultPackagesPayload): string[] {
  return Object.keys(searchPayload).length === 0 ? [] : searchPayload.Categories || [];
}

export function mapFiltersSearchHotelPackage(filters: HotelFiltersResponse, resultsCounts: number): HotelFiltersResponse {
  return mapFiltersReduce(filters, resultsCounts) as HotelFiltersResponse;
}
